<template>
  <aside
      v-show="isAsideVisible"
      class="aside is-placed-left is-expanded">
    <aside-tools :is-main-menu="true">
      <div slot="label">
        <div class="aside-logo">
          <img src="@/assets/logo_white.png" alt="logo"/>
        </div>
        <div class="aside-title">
          Escuela del Arte Ecuestre de Chile
        </div>
      </div>
    </aside-tools>
    <div class="menu is-menu-main">
      <template v-for="(menuGroup, index) in menu" >
        <p class="menu-label" v-if="typeof menuGroup === 'string'" :key="index">{{ menuGroup }}</p>
        <aside-menu-list
            v-else
            :key="index"
            @menu-click="menuClick"
            :menu="menuGroup"/>
      </template>
    </div>
    <div class="menu-footer">{{ appVersion }} <br> &copy; Nobleza del Parque - {{ year }}</div>
  </aside>
</template>

<script>
import { mapState } from 'vuex'
import AsideTools from '@/components/AsideTools'
import moment from 'moment'
import Environment from '../environments/environment'

export default {
  name: 'AsideMenu',
  components: { AsideTools },
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      appVersion: Environment.PASSAGE_APP_VERSION
    }
  },
  computed: {
    ...mapState([
      'isAsideVisible'
    ]),
    year () {
      return moment().year()
    }
  },
  methods: {
    menuClick (item) {
      //
    }
  }
}
</script>
